export const CCF = {
    Location: "Products",
 
  
    Header: "Ceiling & Cabinet Fans",
    Img: "https://solerpalau-usa.com/images/products/ccf/Losone-Select-Ceiling.webp",
    Disc: "Losone Select Series",
    Disc2: "Ceiling and Cabinet Ventilators",
    Disc3: "Model number formally FF, FFC",
    Overview: "The extremely quiet Losone Select Series ventilators are available from 100 to 1,891 CFM, with static pressure capabilities to 1”.All units have centrifugal blower wheels and low RPM motors on resilient mounts. The forward curved centrifugal wheel with its high static pressure capability makes these ventilators suitable for either ducted or nonducted applications. They include removable blower assemblies and plug-in permanently lubricated motors for ease of servicing and cleaning.",
    Link: "",
};

export const CFSF_KSFV = {
    Location: "Products",
 
    Header: "Centrifugal Filtered Supply Fans",
    Img: require("../../assests/img/KSFV.webp"),
    Disc: "KSFV",
    Disc2: "Belt Drive Kitchen Supply Fan with Variations",
    Overview: "The KSFV fans are roof curb or curb cap mounted filtered supply fans rated from 475 to over 12,600 CFM, with static pressure capabilities to 2-1/2\" They are specifically designed for non-tempered, filtered make-up air in kitchen hood applications. KSFV construction includes galvanized construction to provide maximum weather protection, long life and the utmost in performance efficiency. The forward curved centrifugal blower provides efficient airflow at low sound levels with static pressure capabilities to handle ducted air systems or hoods within a building. The filters are washable and are reusable to reduce maintenance costs.",
    Link: "",
};
export const CFSF_CSF = {
   
    Location: "Products",
    Header: "Centrifugal Filtered Supply Fans",
    Img: require("../../assests/img/CSF.webp"),
    Disc: "CSF",
    Disc2: "Belt Drive Centrifugal Filtered Roof Supply Fan",
    Overview: "Centrifugal Filtered Supply Fans units are roof mounted filtered supply fans rated from 375 to over 13,000 CFM, with static pressure capability up to 2\"  rugged, heavy-gauge galvanized hood and stack provide maximum weather protection and long life. All models are belt driven for easier performance adjustment and quieter operation. Adjustable motor pulleys further simplify fan speed changes.",
    Link: "",
};
export const CFSF_LSF = {
   
    Location: "Products",
    Header: "Centrifugal Filtered Supply Fans",
    Img: require("../../assests/img/LSF.webp"),
    Disc: "LSF",
    Disc2: "Belt Drive Centrifugal Filtered Roof Supply Fan with Louvered Housing",
    Overview: "Louver Filtered Supply Fans units are roof mounted filtered supply fans rated from 375 to over 13,000 CFM, with static pressure capabilities to 2\". LSFs architecturally pleasing; heavy-gauge aluminum louver design provides long life and the utmost in performance efficiency. All models are belt driven for easier performance adjustment and quieter operation. Adjustable motor pulleys further simplify fan speed changes.",
    Link: "",
};

export const CRWF_SDBD = {
    
    Location: "Products",
    Header: "Centrifugal Roof & Wall Fans",
    Img: require("../../assests/img/SDBD.webp"),
    Disc: "SDBD and SDBDe",
    Disc2: "Downblast Direct Drive Centrifugal Roof Exhaust Fans",
    Overview: "SDBD and SDBDe direct drive fans are designed to exhaust air up to 4,984 CFM, with high static pressure capability up to 1-1/2\" The non-overloading backward inclined wheel with its higher static pressure capability makes these units suitable for either ducted or non-ducted applications. The spun aluminum exterior provides an attractive appearance. Direct drive units use smaller diameter wheels, resulting in low sound levels and quiet operation. They have no belts or fan bearings to maintain or adjust and consequently require very little maintenance. Its roof mounting permits short duct runs and more efficient operation.",
    Link: "",
};

export const CRWF_SDB = {

    Location: "Products",
    Header: "Centrifugal Roof & Wall Fans",
    Img: require("../../assests/img/SDB.webp"),
    Disc: "SDB",
    Disc2: "Belt Drive Centrifugal Downblast Roof Exhaust Fan",
    Overview: "The SDB belt drive fans are designed to exhaust air up to 31,563 CFM in high static pressure applications up to 1-3/4\". The aluminum exterior provides an attractive appearance. Belt drive results in lower operating RPM and sound levels, making the Model SDB well suited to applications where quiet operation is important. Belt drive also permits easy performance adjustments when needed to balance the total ventilation system. The non-overloading backward inclined wheel with its higher static pressure capability makes this unit suitable for either ducted or non-ducted applications. Its roof mounting permits location near the area to be ventilated, allowing short duct runs and more efficient operation.",
    Link: "",
};

export const CRWF_STXD = {
    Location: "Products",
    Header: "Centrifugal Roof & Wall Fans",
    Img: require("../../assests/img/STXB.webp"),
    Disc: "STXD, STXDe, and STXDeRHUL",
    Disc2: "Upblast Direct Drive Centrifugal Roof/Sidewall Exhaust Fans",
    Overview: "The STXD direct drive fans are designed to exhaust air up to 4,780 CFM, with high static pressure capability up to 1-1/2\". The non-overloading backward inclined wheel, with its higher static pressure capability, makes this unit suitable for either ducted or non-ducted applications. Its roof or wall mounting permits short duct runs and more efficient operation. Direct drive units use smaller diameter wheels with lower RPM's, resulting in low sound levels and quiet operation. They have no belts or fan bearings to maintain or adjust and consequently require very little maintenance.",
    Link: "",
};


export const CRWF_STXB = {
    Location: "Products",
    Header: "Centrifugal Roof & Wall Fans",
    Img: require("../../assests/img/STXB.webp"),
    Disc: "STXB, STXB-RHUL, and STXB-HP",
    Disc2: "Upblast Belt Drive Centrifugal Roof/Sidewall Exhaust Fans",
    Overview: "STXB and STXB-RHUL Upblast Belt Drive Centrifugal Roof/Sidewall Exhaust Fans are designed to exhaust air up to 37,920 CFM in high static pressure applications to 3\". The aluminum exterior provides an attractive appearance. Belt drive results in lower operating RPM and sound levels, making the Series STXB well suited to applications where quiet operation is important. Belt drive also permits easy performance adjustments when needed to balance the total ventilation system. The non-overloading backward inclined wheel with its higher static pressure capability makes this unit suitable for either ducted or non-ducted applications. Its roof or sidewall mounting options permit location near the area to be ventilated, allowing short duct runs and more efficient operation.",
    Link: "",
};



export const CRWF_STXB_HT2_HT = {
    Location: "Products",
    Header: "Centrifugal Roof & Wall Fans",
    Img: require("../../assests/img/STXB.webp"),
    Disc: "STXB-HT2 and STXB-HT",
    Disc2: "High Temperature Upblast Belt Drive Centrifugal Roof Exhaust Fans",
    Overview: "The STXB is now available with the UL Smoke Control Options (HT2 and HT). These fans can provide emergency heat and smoke ventilation in the event of a fire, which can provide valuable time to people exiting or emergency personnel. The HT2 has a steel wheel and is certified to exhaust heat and smoke in emergencies [500°F (260°C) for 4 hours and 1,000°F (538°C) for 15 minutes]. The HT has an aluminum wheel and is certified to exhaust heat and smoke in emergencies [500°F (260°C) for 4 hours].",
    Link: "",
};

export const CRWF_LPD_SF = {
    Location: "Products",
    Header: "Centrifugal Roof & Wall Fans",
    Img: require("../../assests/img/LPD.webp"),
    Disc: "LPD and LPD-SF",
    Disc2: "Low Profile Direct Drive Centrifugal Roof/Sidewall Exhaust Fans",
    Overview: "LPD and LPD-SF direct drive fans are designed to exhaust air in low CFM (up to 420), with high static pressure capability up to 1-3/4\". When aesthetics are a concern, the low profile design of the LPD is the perfect choice. The LPD is generally used for bathroom, office or light commercial ventilation in ducted systems; and can be mounted either on the roof or wall as the application requires. The LPD is designed for curb mounting. The LPD-SF has a flat, self-flashing base for roof or sidewall mounting.",
    Link: "",
};

export const CRWF_CWD = {
    Location: "Products",
    Header: "Centrifugal Roof & Wall Fans",
    Img: require("../../assests/img/CWD.webp"),
    Disc: "CWD",
    Disc2: "Direct Drive Centrifugal Sidewall Exhaust Fan",
    Overview: "Centrifugal Wall Mounted Exhauster Direct Drive Fans (CWD) is designed to exhaust air up to 3,360 CFM, with high static pressure capability up to 1\". The spun aluminum exterior provides a pleasing appearance, weatherproof construction, and resistance to corrosion. The low silhouette design is less noticeable on the building exterior, and the removable dome provides easy access to the fan interior for service and cleaning. The non-overloading backward inclined centrifugal wheel with its high static pressure capability makes it suitable for either ducted or non-ducted applications. It should be used where a sidewall mounted location is preferred to roof mounting. Direct drive units use smaller diameter wheels with lower RPM's, resulting in low sound levels and quieter operation. They have no belts or fan bearings to maintain or adjust and consequently require very little maintenance.",
    Link: "",
};



export const ERV_TR = {
    Location: "Products",
    Header: "Energy Recovery Ventilators by S&P",
    Img: require("../../assests/img/TR.webp"),
    Disc: "TR",
    Disc2: "Total Recovery for All Climates",
    Overview: "To protect the two most valuable investments of your life, your home, and your family, improving indoor air quality is key. With S&P's TR Series for all climates, stale room air is exhausted, and the fresh outdoor air is brought back into the house. With this line of ERVs, these two air streams are directed through a highly developed \"air-to-air\" energy exchange core. The air streams are physically separated by many layers of \"plates\" so there is no mixing or contamination of the fresh air. The plates are made of an engineered \"resin\" material that simultaneously transfers heat by conduction and humidity by attracting and moving water vapor from one air stream to the other.",
    Link: "",
};

export const ERV_TRe = {
    Location: "Products",
    Header: "Energy Recovery Ventilators by S&P",
    Img: require("../../assests/img/TRe.webp"),
    Disc: "TRe",
    Disc2: "Total Recovery Premium",
    Overview: "Total Recovery Premium, TRe, is the latest edition to S&P USA's line of Energy Recovery Ventilators. TRe can be used in any orientation and features an EC motor for great energy efficiency. Utilize TRe for any residential or light commercial project by individually balancing each airstream to account for variations of duct run lengths.",
    Link: "",
};

export const ERV_TRC = {
    Header: "Energy Recovery Ventilators by S&P",
    Img: require("../../assests/img/TRC.webp"),
    Disc: "TRC",
    Disc2: "Total Recovery for All Climates (Commercial Applications)",
    Overview: "With S&P's TRC Series for all climates, stale room air is exhausted, and the fresh outdoor air is brought back into the building. With this line of ERVs, these two air streams are directed through a highly developed \"air-to-air\" energy exchange core. The air streams are physically separated by many layers of \"plates\" so there is no mixing or contamination of the fresh air. The plates are made of an engineered \"resin\" material that simultaneously transfers heat by conduction and humidity by attracting and moving water vapor from one air stream to the other.",
    Link: "",
};

export const ERV_TRCe = {
    Header: "Energy Recovery Ventilators by S&P",
    Img: require("../../assests/img/TRC.webp"),
    Disc: "TRCe",
    Disc2: "Total Recovery with EC Motor for All Climates",
    Overview: "With S&P's TRCe (total recovery for commercial applications) Series with EC Motor for all climates, stale room air is exhausted, and the fresh outdoor air is brought back into the building. With this line of ERVs (Energy Recovery Ventilators) these two air streams are directed through a highly developed \"air-to-air\" energy exchange core. The air streams are physically separated by many layers of \"plates\" so there is no mixing or contamination of the fresh air. The plates are made of an engineered \"resin\" material that simultaneously transfers heat by conduction and humidity by attracting and moving water vapor from one air stream to the other.",
    Link: "",
};

export const GV_RCXII_SF = {
    Location: "Products",
    Header: "Gravity Vents",
    Img: require("../../assests/img/RCXII.webp"),
    Disc: "RCXII and RCXII-SF",
    Disc2: "Gravity Relief/Intake Ventilators",
    Overview: "RCXII and RCXII-SF relief or intake ventilators feature low contour spun aluminum hoods for an attractive appearance. They are designed to exhaust or supply air from or to an enclosed area without the need for a power operated fan. Available in two styles, these fans range in sizes from 6 to 36\". The RCXII has a curb cap found on most roof ventilators and must be mounted on a roof curb. RCXII-SF has an extra wide, flat base that installs under roof shingles and does not require a roof curb. Both styles come standard with a galvanized birdscreen.",
    Link: "",
};

export const GV_RLX = {
    Location: "Products",
    Header: "Gravity Vents",
    Img: require("../../assests/img/RLX.webp"),
    Disc: "RLX",
    Disc2: "Louvered Penthouse",
    Overview: "RLX Aluminum Louvered Penthouse provides a low silhouette and modern design for fresh air intake, pressure relief, and gravity applications. With hundreds of optional lengths and heights available, the RLX is frequently used for enclosing unsightly rooftop equipment. The storm-resistant aluminum louver design provides weather integrity when properly sized. Catalog capacity ranges from 395 to 69,500 CFM with much greater ranges available in custom sizes. Companion, louvered fan Model LSF offers continuity in rooftop equipment designs.",
    Link: "",
};

export const GV_BGH = {
    Location: "Products",
    Header: "Gravity Vents",
    Img: require("../../assests/img/BGH.webp"),
    Disc: "BGH",
    Disc2: "Fabricated Gravity Relief/Intake Ventilator",
    Overview: "BGH Gravity Ventilators offer a modern low silhouette design that blend with roof lines and other equipment. Designed for maximum airflow passage and weathertight integrity, BGH comes in either intake or relief models with aluminum or galvanized finishes. An extensive range of sizes is offered with many standard and optional features. Exhaust models have a 1:1 ratio of hood perimeter opening to throat area and supply models incorporate a 2:1 ratio.",
    Link: "",
};


export const HVLSF_Tornado = {
    Location: "Products",
    Header: "High Volume Low Speed Fans",
    Img: require("../../assests/img/tornado.webp"),
    Disc: "Tornado HVLS",
    Disc2: "5-Blade High Volume Low Speed Fan",
    Overview: "Tornado HVLS is a 5-Blade High Volume Low-Speed fan model featuring a direct drive ECM, IP65 motor. This fan is equipped with wingtips to redirect outward airflow downward.  Through the destratification process, the THVLS fan series will lower energy bills providing evaporative cooling effect in summer and allow for uniform temperature in winter.",
    Link: "",
};

export const HVLSF_Tempest = {
    Location: "Products",
    Header: "High Volume Low Speed Fans",
    Img: require("../../assests/img/tempest.webp"),
    Disc: "Tempest HVLS",
    Disc2: "6-Blade High Volume Low Speed Fan",
    Overview: "Tempest HVLS is a 6-Blade High Volume Low-Speed fan model featuring a direct drive ECM, IP65 motor. This fan is equipped with wingtips to redirect outward airflow downward.  Through the destratification process, the THVLS fan series will lower energy bills providing evaporative cooling effect in summer and allow for uniform temperature in winter.",
    Link: "",
};


export const ILSDF_MIXVENT = {
    Location: "Products",
    Header: "In-line/Sidewall Duct Fans",
    Img: require("../../assests/img/TD-MIXVENT.webp"),
    Disc: "TD-MIXVENT by S&P",
    Disc2: "In-line Mixed Flow Duct Fan",
    Overview: "The TD-MIXVENT series is an in-line duct fan specially designed to maximize the airflow performance with minimal noise levels in a small, compact housing. This makes the TD-MIXVENT series the ultimate solution for small to medium sized ventilation installations which require a high airflow to pressure ratio and occupy minimum space (e.g., false ceiling voids, cabinets and many other limited space environments).",
    Link: "",
};

export const ILSDF_SILENT = {
    Location: "Products",
    Header: "In-line/Sidewall Duct Fans",
    Img: require("../../assests/img/TD-SILENT.webp"),
    Disc: "TD-SILENT by S&P ",
    Disc2: "In-line Mixed Flow Duct Fan (Designed for Rigid Duct Applications)",
    Overview: "The TD-SILENT fans are extremely quiet, low profile fans manufactured in the tough reinforced plastic material. Sound waves are directed through the perforated inner skin and absorbed by a layer of sound-absorbent insulation. These fans are fitted with rubber gaskets on the inlet and outlet to facilitate installation, absorb vibrations, and provide a virtually air-tight seal.",
    Link: "",
};

export const ILSDF_PVDEDPV = {
    Location: "Products",
    Header: "In-line/Sidewall Duct Fans",
    Img: require("../../assests/img/PV-DEDPV.webp"),
    Disc: "PV-DEDPV by S&P",
    Disc2: "Dryer Exhaust Duct Power Ventilator",
    Overview: "The PV-DEDPV is a UL 705 listed Dryer Exhaust Duct Power Ventilator. It effectively helps residential clothes dryers overcome the high static pressure caused by long duct runs between the dryer and wall or roof cap.",
    Link: "",
};

export const ILSDF_POWERVENT = {
    Location: "Products",
    Header: "In-line/Sidewall Duct Fans",
    Img: require("../../assests/img/PV.webp"),
    Disc: " PV-POWERVENT by S&P",
    Disc2: "In-line Centrifugal Duct Fan",
    Overview: "The POWERVENT (PV) series of direct drive centrifugal in-line duct ventilation fans consists of six model sizes 4\", 5\", 6\", 8\", 10\" and 12.4\" respectively. All models are designed for direct connection in-line with standard diameter round ducting. Airflow performance values range from 153 CFM (PV-100X) up to 943 CFM (PV-315X).",
    Link: "",
};

export const ILSDF_PRF_RADON = {
    Location: "Products",
    Header: "In-line/Sidewall Duct Fans",
    Img: require("../../assests/img/PRF.webp"),
    Disc: "PRF-RADON MITIGATION by S&P",
    Disc2: "",
    Overview: "PRF fans are specifically designed for radon mitigation. The fully-sealed plastic fans feature backward inclined centrifugal blower/motors capable of handling up to 1\ of static pressure. The PRF series has duct lips sized for an easy fit with standard PVC couplings typically used in radon mitigation applications. Additionally, the PRF was engineered with large, easily accessible, watertight electrical boxes for unobstructed wiring process.",
    Link: "",
};

export const ILSDF_SWF = {
    Location: "Products",
    Header: "In-line/Sidewall Duct Fans",
    Img: require("../../assests/img/SWF.webp"),
    Disc: "SWF-SIDEWALL by S&P",
    Disc2: "Sidewall Centrifugal Fan",
    Overview: "The Sidewall Fan Series utilizes the same powerful high static motor found in the popular PV Series fans, yet the SWF series is encased in an exterior mounted housing. The outdoor rated exterior housing provides easy access from the outside of a building or dwelling. This makes the SWF a great solution for installations where attic space or easy indoor access is challenging and not suitable for traditional PV style in-line mounting. The SWF series of direct drive centrifugal ventilation fans consists of five model sizes ranging from 4-8\". All models are designed for direct connection in-line with standard diameter round ducting. Airflow performance values range from 119 to 416 CFM.",
    Link: "",
};

export const ILSDF_SMXD = {
    Location: "Products",
    Header: "In-line/Sidewall Duct Fans",
    Img: require("../../assests/img/SMXD.webp"),
    Disc: "SMXD",
    Disc2: "Direct Drive Mixed Flow Fan",
    Overview: "SMXD series is an direct drive mixed flow fan specially designed to maximize the airflow performance by acting as a hybrid between an axial and centrifugal fan. They produce a great amount of air while being able to handle higher pressures. It is more efficient and quieter than comparable tubular centrifugal fans. These fans can be used in exhaust, supply or return air applications.",
    Link: "",
};

export const ILSDF_SMXD_HT = {
    Location: "Products",
    Header: "In-line/Sidewall Duct Fans",
    Img: require("../../assests/img/SMXD.webp"),
    Disc: "SMXD-HT",
    Disc2: "Direct Drive Mixed Flow Fan",
    Overview: "SMXD-HT series is a direct drive mixed flow fan specially designed to maximize the airflow performance by acting as a hybrid between an axial and centrifugal fan. This HT (high temperature) model can provide emergency heat and smoke ventilation in the event of a fire, which can provide valuable time to people exiting or emergency personnel. The SMXD-HT is UL Certified to exhaust heat and smoke in emergencies [500℉ (260℃) for 6 hours and 572℉ (300℃) for 2 hours].",
    Link: "",
};

export const ILSDF_SMXDK = {
    Location: "Products",
    Header: "In-line/Sidewall Duct Fans",
    Img: require("../../assests/img/smxdk.webp"),
    Disc: "SMXDK",
    Disc2: "Direct Drive Mixed Flow Fan",
    Overview: "Model SMXDK mixed flow fans are inline ducted fans that can be used in exhaust, supply, or return air applications. Mixed flow fans act as a hybrid between axial and centrifugal fans. Meaning, they produce a lot of air such as axial fans, but they can handle higher pressures like centrifugal fans. When these technologies come together, the fan ends up being more efficient and quieter than similar tubular centrifugal fans.",
    Link: "",
};

export const ILSDF_SMXDK_HT = {
    Location: "Products",
    Header: "In-line/Sidewall Duct Fans",
    Img: require("../../assests/img/smxdk.webp"),
    Disc: "SMXDK-HT",
    Disc2: "Direct Drive Mixed Flow Fan",
    Overview: "SMXDK-HT series is a direct drive mixed flow fan specially designed to maximize the airflow performance by acting as a hybrid between an axial and centrifugal fan. This HT (high temperature) model can provide emergency heat and smoke ventilation in the event of a fire, which can provide valuable time to people exiting or emergency personnel.",
    Link: "",
};

export const ILSDF_SQB = {
    Location: "Products",
    Header: "In-line/Sidewall Duct Fans",
    Img: require("../../assests/img/SQB.webp"),
    Disc: "SQB",
    Disc2: "Belt Drive Square Inline Centrifugal Duct Fan",
    Overview: "SQB square in-line duct mounted fans are available in sizes 7 through 42, moving from 100 to over 24,000 CFM, with high static pressure capability up to 3-1/2\". SQB units are the perfect selection for clean air applications where space is a leading consideration. The compact housing with removable access doors and side discharge can be mounted in any orientation. AMCA licensed performance and UL listing assure that you've made a reliable selection.",
    Link: "",
};

export const ILSDF_SQD_eSQD = {
    Location: "Products",
    Header: "In-line/Sidewall Duct Fans",
    Img: require("../../assests/img/SQD.webp"),
    Disc: "SQD and eSQD",
    Disc2: "Direct Drive Square Inline Centrifugal Duct Fans",
    Overview: "The SQD square inline duct mounted fan is available in sizes 6 through 15, moving up to 2,800 CFM, with static pressure capability up to 1\". eSQD with electronically commutated (EC) motors are square inline duct mounted fan is available in sizes 8, 10, and 12. SQD units are the perfect selection for clean air applications where space is a leading consideration. The compact housing with removable access doors and side discharge capability can be mounted in any orientation.",
    Link: "",
};

export const ILSDF_CTB = {
    Location: "Products",
    Header: "In-line/Sidewall Duct Fans",
    Img: require("../../assests/img/CTB.webp"),
    Disc: "CTB and CTBRHUL",
    Disc2: "Inline Tubular Centrifugal Fans",
    Overview: "The Inline Tubular Centrifugal (CTB) series offers one of the widest ranges of sizes, horsepower, and performance in the industry. Models CTB are high capacity belt drive tubular centrifugal fans rated from 300 to 20,000 CFM, with static pressure capability up to 2-1/2\". These fans are designed for commercial and industrial in-line applications that demand quiet, efficient and reliable air movement. They are used to exhaust air from or supply air to commercial and industrial applications, such as, general building ventilation, enclosed garages, paint spray booths, heat and smoke ventilation systems, restaurant and kitchen exhaust ventilation, historical buildings with limited roof space and restrictive duct lengths, and other applications where air is moved through a duct system against moderate static pressure.",
    Link: "",
};

export const ILSDF_CFD = {
    Location: "Products",
    Header: "In-line/Sidewall Duct Fans",
    Img: require("../../assests/img/CFD.webp"),
    Disc: "CFD",
    Disc2: "Forward Curved Belt Drive In-line Duct Blower",
    Overview: "The Forward Curved Belt Driven Inline Duct Blowers (CFD) are designed for supply, exhaust or duct return applications. The CFD is an economical fan model designed to run quietly and efficiently in cooling, heating, and ventilating applications.",
    Link: "",
};




export const JetFans_IFFT = {
    Location: "Products",
    Header: "Jet Fans Series",
    Img: require("../../assests/img/ifft.webp"),
    Disc: "IFFT and IFFTe",
    Disc2: "Centrifugal Jet Fan",
    Overview: "The IFFT centrifugal jet fans were designed with relative compactness and efficiency in mind. They are perfect for moving a great deal of air to keep a parking garage safe. The fans induce air flow to move dangerous gases out of enclosed garages and to dedicated ventilation points.",
    Link: "",
};

export const JetFans_TJFU = {
    Location: "Products",
    Header: "Jet Fans Series",
    Img: require("../../assests/img/tjfu.webp"),
    Disc: "TJFU",
    Disc2: "Axial Jet Fan",
    Overview: "The TJFU axial jet fans were designed with relative compactness and efficiency in mind. They are perfect for moving a great deal of air to keep a parking garage safe. The fans induce air flow to move dangerous gasses out of enclosed garages and to dedicated ventilation points. Jet fans eliminate the need for ductwork throughout parking areas which reduces installation costs.",
    Link: "",
};

export const JetFans_IFAB_IFEB= {
    Location: "Products",
    Header: "Jet Fans Series",
    Img: require("../../assests/img/ifab.webp"),
    Disc: "IFAB and IFEB",
    Disc2: "Low Profile Compact Centrifugal Jet Fan",
    Overview: "The IFAB and IFEB low profile jet fans were designed with compactness and efficiency in mind. They are perfect for moving a great deal of air, to keep a parking garage safe, while fitting in a low ceiling. The efficient impellers keep ventilation costs down, and the low weight of the designs allow the fans to be installed rapidly and effortlessly. The IFAB uses AC impellers and the IFEB uses EC impellers. The IFEB improves the efficiency of the units by using the latest in EC motor technology.",
    Link: "",
};

export const JetFans_VGD = {
    Location: "Products",
    Header: "Jet Fans Series",
    Img: require("../../assests/img/vgd.webp"),
    Disc: "6002, 6002-14B, 6002A and 6002-14A",
    Disc2: "Ventilation Gas Detectors",
    Overview: "Models 6002, 6002-14B, 6002A and 6002-14A offer precision to assure the health and safety to occupants with the tightest possible controls on energy consumption. They are versatile, self-contained dual gas sensors that are network ready for either peer-to-peer (master slave) operation or central control for a smooth integration into new or existing energy management systems.",
    Link: "",
};





export const KitchenHoods_EO = {
    Location: "Products",
    Header: "Kitchen Hoods",
    Img: require("../../assests/img/EO.webp"),
    Disc: "EO",
    Disc2: "Exhaust Only Kitchen Hood",
    Overview: "The Exhaust Only (EO) hood model is an exhaust only canopy style hood. Superior airflow rates and versatile configurations make the EO hood model suitable for all cooking applications.",
    Link: "",
};

export const KitchenHoods_EO_FPSP = {
    Location: "Products",
    Header: "Kitchen Hoods",
    Img: require("../../assests/img/eo-fpsp.webp"),
    Disc: "EO-FPSP",
    Disc2: "Exhaust Only Kitchen Hood with Front Perforated Supply Plenum",
    Overview: "The Exhaust Only Kitchen Hood with Front Perforated Supply Plenum (EO-FPSP) is an exhaust only canopy style hood. The FPSP is field installed and discharges the make-up air down across the face of the hood. The FPSP hood is built with internal V-shaped perforated balancing plates that ensure the make-up air is evenly distributed across the full length of the plenum.",
    Link: "",
};

export const KitchenHoods_EOLC = {
    Location: "Products",
    Header: "Kitchen Hoods",
    Img: require("../../assests/img/EOLC.webp"),
    Disc: "EOLC",
    Disc2: "Exhaust Only Low Ceiling Kitchen Hood",
    Overview: "The Exhaust Only Low Ceiling (EOLC) hood model is an exhaust only canopy style hood. The EOLC hood is built with a short front design that allows for more headroom in low ceiling applications. The EOLC hood is only recommended for use where additional headroom is needed and is suitable for most cooking applications.",
    Link: "",
};

export const KitchenHoods_EOLC_FPSP = {
    Location: "Products",
    Header: "Kitchen Hoods",
    Img: require("../../assests/img/EOLC-FPSP.webp"),
    Disc: "EOLC-FPSP",
    Disc2: "Exhaust Only Low Ceiling Kitchen Hood with Front Perforated Supply Plenum",
    Overview: "The Exhaust Only Low Ceiling Kitchen Hood with Front Perforated Supply Plenum (EOLC-FPSP) is an exhaust only canopy style hood. The EOLC-FPSP hood is built with a short front design that allows for more headroom in low ceiling applications. The FPSP hood is built with internal V-shaped perforated balancing plates that ensure the make-up air is evenly distributed across the full length of the plenum.",
    Link: "",
};

export const OAMDK__ = {
    Location: "Products",
    Header: "Outside Air Motorized Damper Kits",
    Img: require("../../assests/img/MD.webp"),
    Disc: "Outside Air Motorized Damper Kits",
    Disc2: "",
    Overview: "The MDX-ES24VK from S&P allows air to enter dwellings to meet building code and ventilation standards requirements through a motorized damper controlled by a 24V temperature/humidity monitoring control. The control can command the central HVAC blower to help distribute fresh air through the existing duct work if necessary.",
    Link: "",
};

export const PC = {
    Location: "Products",
    Header: "",
    Img: "",
    Disc: "",
    Disc2: "",
    Overview: "",
    Link: "",
};

export const Refresh_Full = {
    Location: "Products",
    Header: "reFresh Series by S&P",
    Img: require("../../assests/img/FullSize.webp"),
    Disc: "reFresh Full Size Units",
    Disc2: "",
    Overview: "All-in-one units to introduce fresh air from the outside into the residence. The reFresh series is specifically engineered to meet building and energy codes that call for ASHRAE 62.2 CFM requirements. The reFresh Full Size Units have set speeds at 40, 100, and 170 CFM (Low, Medium, and High).",
    Link: "",
};

export const Refresh_Low = {
    Location: "Products",
    Header: "reFresh Series by S&P",
    Img: require("../../assests/img/LowProfile.webp"),
    Disc: "reFresh Low Profile",
    Disc2: "",
    Overview: "Low profile, all-in-one units to introduce fresh air from the outside into the residence. The reFresh series is specifically engineered to meet building and energy codes that call for ASHRAE 62.2 CFM requirements. The reFresh Full Size Units have set speeds at 40, 100, and 140 CFM (Low, Medium, and High)",
    Link: "",
};

export const Refresh_Value = {
    Location: "Products",
    Header: "reFresh Series by S&P",
    Img: require("../../assests/img/RFV.webp"),
    Disc: "reFresh Value",
    Disc2: "",
    Overview: "The reFresh Value Series introduces fresh air from the outside into the residence. The value model is specifically engineered to meet building and energy codes that call for ASHRAE 62.2 (2010), IRC (2012/2015), and IMC (2012/2015) requirements.",
    Link: "",
};

export const RPF_UBS = {
    Location: "Products",
    Header: "Roof Propeller Fans",
    Img: require("../../assests/img/UBS.webp"),
    Disc: "UBS and UBS-P",
    Disc2: "Belt Drive Upblast Propeller Roof Exhaust Fan",
    Overview: "UBS and UBS-P are high capacity roof mounted exhausters rated from 7,000 to 51,000 CFM. They are general ventilation units designed to economically remove large volumes of air, fumes, and vapors from commercial and industrial buildings such as warehouses, manufacturing and assembly plants, chemical plants, foundries and paper mills.",
    Link: "",
};

export const RPF_ARE = {
    Location: "Products",
    Header: "Roof Propeller Fans",
    Img: require("../../assests/img/AR.webp"),
    Disc: "ARE and ARS",
    Disc2: "Dome Axial Power Roof Exhaust/Supply Fans",
    Overview: "The AR series offers powerful axial exhaust (ARE) or supply (intake) (ARS) performance in a compact, lightweight and easy to install roof mounted design. Available in 4 model sizes, the AR series has a CFM range from 163 to 2,827 CFM, with static pressure capability up to 3/4\".",
    Link: "",
};

export const RPF_HRSB = {
    Location: "Products",
    Header: "Roof Propeller Fans",
    Img: require("../../assests/img/HRS.webp"),
    Disc: "HRSB and HRSD",
    Disc2: "Hooded Propeller Roof Supply Fans",
    Overview: "HRSB and HRSD are roof mounted supply fans rated from 4,000 to over 56,000 CFM, with static pressure capability up to 3/4\". They are used in a variety of commercial and industrial operations such as warehouses manufacturing plants, equipment and machinery rooms, assembly plants and similar facilities to provide fresh outside air for personal comfort and to reduce negative pressure caused by exhaust systems",
    Link: "",
};

export const RPF_HREB_ = {
    Location: "Products",
    Header: "Roof Propeller Fans",
    Img: require("../../assests/img/HRE.webp"),
    Disc: "HREB-C, HREB-P, and HRED-C",
    Disc2: "Hooded Propeller Roof Exhaust Fans",
    Overview: "Models HREB-C, HREB-P, and HRED-C are roof-mounted, low-profile exhaust fans rated from 4,000 to over 90,000 CFM with 1” static pressure. Eight sizes from 24-72 inches are available. Available in galvanized or aluminum construction, they are used to exhaust air from a variety of commercial and industrial operations such as manufacturing and assembly plants, warehouses, garages, laundries, and similar buildings",
    Link: "",
};

export const RPF_UBSRD = {
    Location: "Products",
    Header: "Roof Propeller Fans",
    Img: require("../../assests/img/UBSRD-HT.webp"),
    Disc: "UBSRD and UBSRD-P",
    Disc2: "Remote Drive Upblast Propeller Roof Exhaust Fan",
    Overview: "Model UBSRD units are high capacity, belt driven roof mounted exhausters rated from 3,700 to 67,000 CFM. The motor and drives are located outside of the exhaust airstream, making these units especially suited for the removal of heated or contaminated air from commercial and industrial buildings or processes where these conditions exist. All models are capable of continuous operation exhausting air to 200°F.",
    Link: "",
};

export const RPF_UBSRD_HT = {
    Location: "Products",
    Header: "Roof Propeller Fans",
    Img: require("../../assests/img/UBSRD-HT.webp"),
    Disc: "UBSRD-HT and UBSRD-HT1",
    Disc2: "Remote Drive Upblast Propeller Roof Exhaust Fans for Heat and Smoke Removal",
    Overview: "UBSRD-HT and UBSRD-HT1 are available in 24, 30, 36, 42, 48, 54 and 60 inch sizes. Horsepower and CFM range to 52,000 CFM and 10HP. These units have been designed and tested for emergency heat and smoke removal. This design also lends itself to normal non-emergency high capacity industrial and commercial roof exhaust applications. These fans successfully passed heat tests of 1000°F for fifteen (15) minutes, and 500°F for over four (4) hours by an independent testing agency.",
    Link: "",
};

export const RPF_TUB = {
    Location: "Products",
    Header: "Roof Propeller Fans",
    Img: require("../../assests/img/TUB-HT.webp"),
    Disc: "TUB",
    Disc2: "Tubeaxial Upblast Propeller Roof Exhaust Fan",
    Overview: "Tubeaxial Upblast Propeller Roof Exhauster Fans (TUB) are designed for high capacity industrial and commercial roof exhaust applications with capacities ranging from 6,210 to 60,116 CFM, with static pressure capability up to 1\". The remote drive configuration of the TUB is especially suited for the removal of fumes, vapors, steam, dust, smoke and contaminated or heated air for continuous operation in air temperatures to 200°F. For temperature ratings to 1000°F and/or IRI requirements refer to TUB-HT.",
    Link: "",
};

export const RPF_TUB_HT = {
    Location: "Products",
    Header: "Roof Propeller Fans",
    Img: require("../../assests/img/TUB-HT.webp"),
    Disc: "TUB-HT",
    Disc2: "Tubeaxial Upblast Propeller Roof Exhaust Fan for Heat and Smoke Removal",
    Overview: "Tubeaxial Upblast Propeller Roof Exhauster for Heat and Smoke Removal Fans (TUB-HT) has been designed and tested for emergency heat, and smoke removal with horsepower's up to 15 HP and CFM up to 57,000. This design also lends itself to normal non-emergency high capacity industrial and commercial roof exhaust applications. TUB-HT's successfully passed heat tests of 1000°F for fifteen (15) minutes, and 500°F for over four (4) hours by an independent testing agency. TUB-HT exceeds I.R.I (Industrial Risk Insurers) guidelines and is UL-793 Listed as \"Power Ventilator for Smoke Control Systems.\"",
    Link: "",
};

export const RPF_UBB = {
    Location: "Products",
    Header: "Roof Propeller Fans",
    Img: require("../../assests/img/UB.webp"),
    Disc: "UBB and UBX",
    Disc2: "Upblast Propeller Roof Exhaust Fans",
    Overview: "UBB and UBX are high capacity roof mounted exhausters rated from 5,900 to 78,000 CFM. They are general ventilation units designed to economically remove large volumes of air, fumes, and vapors from commercial and industrial buildings such as warehouses, manufacturing and assembly plants, distribution centers, chemical plants, foundries and paper mills.",
    Link: "",
};

export const RPF_UBRD = {
    Location: "Products",
    Header: "Roof Propeller Fans",
    Img: require("../../assests/img/UBRD.webp"),
    Disc: "UBRD",
    Disc2: "Remote Drive Upblast Propeller Roof Exhaust Fan",
    Overview: "UBRD units are high capacity belt driven roof mounted exhausters rated from 4,500 to 72,000 CFM. The motor and drives are located outside of the exhaust airstream, making these units especially suited for the removal of heated or contaminated air from commercial and industrial buildings or processes where these conditions exist. All models are capable of continuous operation exhausting air to 200°F.",
    Link: "",
};



export const SPF_ACF = {
    Location: "Products",
    Header: "Sidewall Propeller Fans",
    Img: require("../../assests/img/ACF.webp"),
    Disc: "ACF by S&P",
    Disc2: "Agricultural Circulating Fan",
    Overview: "Constructed with galvanized steel for long-lasting corrosion resistance, ACF48 is a high-quality fan at an exceptional price. Featuring an IP55 motor rating and permanently sealed ball bearings, this fan is constructed for agricultural, commercial and industrial jobs. Installation is easy through mounting holes directly on the frame. Optional accessories include a wall box kit.",
    Link: "",
};

export const SPF_WA = {
    Location: "Products",
    Header: "Sidewall Propeller Fans",
    Img: require("../../assests/img/WA.webp"),
    Disc: "WA by S&P",
    Disc2: "COMPACT Axial Wall Exhaust Fan",
    Overview: "The COMPACT Axial Wall Exhaust Fan is an extremely compact design created by the combination of an external rotor motor matched with a direct drive wrapped around an impeller hub. This very low profile design optimizes airflow performance while minimizing noise generation.",
    Link: "",
};

export const SPF_LCE_LCS = {
    Location: "Products",
    Header: "Sidewall Propeller Fans",
    Img: require("../../assests/img/LCE.webp"),
    Disc: "LCE and LCS",
    Disc2: "Belt Drive Sidewall Propeller Exhaust/Supply Fans",
    Overview: "LCE (exhaust) and LCS (supply) are high capacity belt driven propeller fans rated from 3,000 to 40,000 CFM, with static pressure capability up to 5/8\" w.g. Their primary application is the exhaust or supply of large volumes of air at relatively low static pressures from commercial, light industrial and agricultural buildings such as manufacturing and assembly plants, warehouses, parking garages, gymnasiums, equipment rooms, distribution centers, poultry houses, and greenhouses.",
    Link: "",
};

export const SPF_L2E_L2S = {
    Location: "Products",
    Header: "Sidewall Propeller Fans",
    Img: require("../../assests/img/L2.webp"),
    Disc: "L2E and L2S",
    Disc2: "Belt Drive Sidewall Propeller Exhaust/Supply Fans",
    Overview: "L2E (exhaust) and L2S (supply) are high capacity wall mounted belt driven propeller fans rated from 5,000 to 47,000 CFM, with static pressure capability up to 3/4\" w.g. Their primary application is the exhaust of large volumes of ventilation air from commercial and light industrial buildings such as manufacturing and assembly plants, warehouses, parking garages, gymnasiums, equipment rooms, distribution centers and OEM applications.",
    Link: "",
};

export const SPF_L3E_L3S = {
    Location: "Products",
    Header: "Sidewall Propeller Fans",
    Img: require("../../assests/img/L3.webp"),
    Disc: "L3E and L3S",
    Disc2: "Belt Drive Sidewall Propeller Exhaust/Supply Fans",
    Overview: "L3E (exhaust) and L3S (supply) are high capacity wall mounted belt driven propeller fans rated from 35,000 to 85,000, with static pressure capability up to 1\" w.g. Their primary application is the exhaust of large volumes of air at a relatively moderate static pressure from commercial, industrial and agricultural buildings such as manufacturing and assembly plants, warehouses, foundries, mills, boiler rooms and equipment rooms.",
    Link: "",
};

export const SPF_GED = {
    Location: "Products",
    Header: "Sidewall Propeller Fans",
    Img: require("../../assests/img/GD.webp"),
    Disc: "GED/eGED and GSD/eGSD",
    Disc2: "Direct Drive Sidewall Propeller Exhaust/Supply Fans",
    Overview: "The GED/eGED and GSD/eGSD Direct Drive Sidewall Propeller Exhaust/Supply Fan features the maximum efficiency, low maintenance and durable, economical operation resulting from the direct drive design. It is available in exhaust configurations to provide general ventilation for a wide variety of buildings and enclosed areas within buildings. Examples include factories, assembly plants, churches, gymnasiums, garages, jails, machine rooms and many others.",
    Link: "",
};

export const SPF_DFE_DFS = {
    Location: "Products",
    Header: "Sidewall Propeller Fans",
    Img: require("../../assests/img/DF.webp"),
    Disc: "DFE and DFS",
    Disc2: "Direct Drive Sidewall Propeller Exhaust/Supply Fans",
    Overview: "The DFE and DFS Direct Drive Sidewall Propeller Exhaust/Supply Fan feature the maximum efficiency, low maintenance and durable, economical operation resulting from the direct drive design. It is available in exhaust configurations to provide general ventilation for a wide variety of buildings and enclosed areas within buildings. Examples include factories, assembly plants, churches, gymnasiums, garages, jails, machine rooms and many others.",
    Link: "",
};

export const SPF_DDE_DDS = {
    Location: "Products",
    Header: "Sidewall Propeller Fans",
    Img: require("../../assests/img/DD.webp"),
    Disc: "DDE and DDS",
    Disc2: "Direct Drive Sidewall Propeller Exhaust/Supply Fans",
    Overview: "The DDE and DDS Direct Drive Sidewall Propeller Exhaust/Supply Fan feature the maximum efficiency, low maintenance and durable, economical operation resulting from the direct drive design. It is available in exhaust configurations to provide general ventilation for a wide variety of buildings and enclosed areas within buildings. Examples include factories, assembly plants, churches, gymnasiums, garages, jails, machine rooms and many others.",
    Link: "",
};



export const TF_DA = {
    Location: "Products",
    Header: "Tubeaxial Fans",
    Img: require("../../assests/img/DA.webp"),
    Disc: "DA by S&P",
    Disc2: "COMPACT Duct Axial Fan",
    Overview: "The COMPACT Duct Axial Fans feature an extremely compact design created by the combination of an external rotor motor matched with a direct drive wrap around an impeller hub. This very low profile design optimizes airflow performance while minimizing noise generation. DA's are designed to be installed in-line with inducted or partially ducted ventilation systems for exhaust or supply air applications.",
    Link: "",
};

export const TF_TDB = {
    Location: "Products",
    Header: "Tubeaxial Fans",
    Img: require("../../assests/img/TDB.webp"),
    Disc: "TDB",
    Disc2: "Belt Drive Tubeaxial In-line Duct Fan",
    Overview: "The Tubeaxial line offers the widest range of sizes, horsepower, and performance in the industry. TDB's are high capacity belt drive tubeaxial fans rated from 900 to 75,490 CFM, with static pressure capability up to 1-1/2\". They are used to exhaust air from or supply air to commercial and industrial applications, such as general building ventilation, enclosed garages, paint spray booths, heat and smoke ventilation systems and other applications where the air is moved through a duct system against moderate static pressure.",
    Link: "",
};

export const TF_TDD = {
    Location: "Products",
    Header: "Tubeaxial Fans",
    Img: require("../../assests/img/TDD.webp"),
    Disc: "TDD",
    Disc2: "Direct Drive Tubeaxial In-line Duct Fan",
    Overview: "The Tubeaxial line offers the widest range of sizes, horsepower, and performance in the industry. TDD's are high capacity tubeaxial fans rated from 643 to 39,194 CFM, with static pressure capability up to 1-1/4\". They are used to exhaust air from or supply air to commercial and industrial applications, such as general building ventilation, enclosed garages, and other applications where the air is moved through a duct system against moderate static pressure.",
    Link: "",
};


export const USV_CM = {
    Location: "Products",
    Header: "Utility Vent Sets",
    Img: require("../../assests/img/CM.webp"),
    Disc: "CM",
    Disc2: "Belt Drive Utility Vent Set",
    Overview: "The CM Series belt driven backward inclined Utility Vent Set fans to offer an excellent choice for all medium and high-pressure exhaust or supply applications for commercial, institutional or light industrial air movement projects. All models are supplied complete with the motor mounted on an adjustable base, v-belt drives, heavy-duty ball bearings and integral mounting platform. The installer-friendly design simplifies and reduces the cost of installation. Each complete fan is tested prior to shipping to ensure smooth, vibration free and consistently reliable operation to provide years of dependable service with minimal maintenance.",
    Link: "",
};